import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from "@angular/core";
import { ButtonDirective } from "primeng/button";

import { QuoteClientEmailDetails } from "app/quote/models/client-email-details.model";
import { QuoteEmailAttachmentsComponent } from "app/quote/quote-form/quote-email-attachments/quote-email-attachments.component";

@Component({
  selector: "app-quote-email-preview",
  templateUrl: "./quote-email-preview.component.html",
  styleUrls: ["./quote-email-preview.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, QuoteEmailAttachmentsComponent],
})
export class QuoteEmailPreviewComponent {
  public readonly details = input.required<QuoteClientEmailDetails>();
  public readonly quoteId = input.required<number>();
  /** Deleting a file is gated on the same permission as editing the quote it belongs to. */
  public readonly canDelete = input<boolean>(false);
  public readonly expanded = signal(true);

  /**
   * Forwarded emails arrive with empty lines between every paragraph that pre-wrap renders
   * verbatim, so the preview reads as double-spaced. Every run of them collapses to a single
   * line break — only empty lines go, joining wrapped ones would destroy addresses and tables.
   * The per-line strip covers non-breaking spaces, or a run of them would survive as content.
   */
  public readonly body = computed<string>(() => {
    const clientBody = this.details().getClientBody();

    if (!clientBody) {
      return "";
    }

    return clientBody
      .replace(/\r\n?/g, "\n")
      .replace(/[^\S\n]+$/gm, "")
      .replace(/\n{2,}/g, "\n")
      .trim();
  });

  public toggle(): void {
    this.expanded.update((expanded) => !expanded);
  }
}
